import { Checkbox, Collapse } from "antd";
import styled from "styled-components";

const collapseBorderColors = {
    p: "#f1691b",
    r: "#1677FF",
    offline: "#d500f9",
    closed: "#49AA19",
    opened: "transparent",
} as const;

export type CollapseBorderColor = keyof typeof collapseBorderColors;

export const StyledCACollapse = styled(Collapse)<{
    $borderColor: CollapseBorderColor;
}>`
    width: 100%;
    border: none;
    border-radius: 0;

    .ant-collapse-content-box {
        padding: 8px;
    }

    .ant-collapse-header {
        background-color: ${({ theme }) => theme.collapseHeaderBackground};
    }

    .ant-collapse-item-active {
        .ant-collapse-header {
            border-radius: 0 10px 0 0 !important;
        }
    }

    border-left: 2px solid
        ${(props) => collapseBorderColors[props.$borderColor]};
`;

export const StyledCACheckbox = styled(Checkbox)<{ $isActive?: boolean }>`
    margin-top: 16px;
    margin-right: 12px;

    --ant-color-primary: ${({ theme }) => theme.colors.green};
    --ant-color-primary-hover: ${({ theme }) => theme.colors.green};
`;
